/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
define(
    [
        'assets/js/modules/pages/start/view/pricingDeliveryView',
        'assets/js/modules/themes/OvernightPrints/modules/pages/start/view/pricingCalcItemView',
        'assets/js/modules/translator',
        'underscore',
        'jquery',
        'assets/js/modules/utils'
    ],
    function(PricingDeliveryView, OnpPricingCalcItemView, translator, _, $, utils) {
        return PricingDeliveryView.extend({
            /**
             * @return {OnpPricingCalcItemView}
             */
            getPricingCalcItemView: function() {
                var defaults = this.getDefaultSelectionData();
                return new OnpPricingCalcItemView({
                    model: this.model.get('pricingCalcItem'),
                    el: this.el,
                    sides: defaults.sides,
                    defaultSkuId: defaults.defaultSkuId
                });
            },
            getDefaultSelectionData: function() {
                var $source = this.$el.find('#product-size-select[data-product-default-sku]');
                if ($source.length) {
                    return {
                        sides: $source.data('product-sides'),
                        defaultSkuId: $source.data('product-default-sku')
                    };
                }

                var startPageModel = this.model;
                var currentProduct = startPageModel.get('product');
                var defaultProductSlug = startPageModel.get('defaultProduct');

                if (currentProduct && currentProduct.get('slug') === defaultProductSlug) {
                    return {
                        sides: startPageModel.get('defaultSides'),
                        defaultSkuId: startPageModel.get('defaultSkuId')
                    };
                }

                return {
                    sides: null,
                    defaultSkuId: null
                };
            },

            renderProducts: function() {
                var _this = this;
                var tmpl = _.template(this.productSizeTemplate);

                if (this.model.get('products').length > 1 && !this.hasRegionWidget()) {
                    var productHtml = this.model.get('products').reduce(function(html, product) {
                        return html + _this.getOptionSizeItemHtml(product);
                    }, '');
                    $('.product-option-choices > ul').append(
                        tmpl({
                            labelText: translator.trans('start_page.calculator.select_product_size', {}, 'start_page'),
                            valuesHtml: productHtml
                        })
                    );

                    this.$productSize.selectBoxIt();
                    this.$productSize = this.$el.find('#product-size-select');
                } else {
                    this.$productSize.closest('li').hide();
                    this.$productSize.find('input:first').attr('checked', true);
                }
            },

            hasRegionWidget: function() {
                return this.$productSize.length > 0;
            },

            /**
             * @param {ProductModel} product
             * @returns {string}
             */
            getOptionSizeItemHtml: function(product) {
                var selectedProductSlug = this.model.get('product').get('slug');
                var selected = product.get('slug') === selectedProductSlug;

                return (
                    '<option value="' + product.get('slug') + '"' + (selected ? ' selected' : '') + '>' + product.get('name') + '</option>'
                );
            },

            updateSubtotalPrice: function() {
                var pricingCalcItem = this.model.get('pricingCalcItem');
                var regularPrice = pricingCalcItem.calculatePrice(true);
                var salePrice = pricingCalcItem.calculateSalePrice(true);

                var $regularPrice = this.$el.find('.regular-price');
                $regularPrice.text(utils.formatPrice(regularPrice, this.model.get('currency')));
                this.$el.find('.sale-price').text(utils.formatPrice(salePrice, this.model.get('currency')));
                if (regularPrice - salePrice < 0.00001) {
                    $regularPrice.hide();
                } else {
                    $regularPrice.show();
                }
            },

            productSizeTemplate: [
                '<li class="product-size-list-item">',
                '<div class="product-choice">',
                '<div class="product-choice-label"><label for="product-size-select"><%= labelText %></label></div>',

                '<div id="product-size-wrapper" class="product-choice-control select-simple">',
                '<select id="product-size-select" class="selectbox"><%= valuesHtml %></select>',
                '</div>',
                '</div>',
                '</li>'
            ].join(''),

            presetCity: function() {
                // do nothing, redesigned start pages do not have shipping inputs
            }
        });
    }
);
